module.exports = __webpack_public_path__ + "media/images/doctor_profiles/errors/error_page_doctor-f87fad75dae801025dcc66adc2c1621f.svg";